import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export default function Packagings() {
    const jwt_access = localStorage.getItem('jwt_access');
    const { me } = useSelector(state => state.auth);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Société Mikalo</title>
            </Helmet>

            <Header />

            <Nav />

            <main id="main">
                <nav className='_menu-tab'>
                    <ul>
                        <li><NavLink end to="/packagings">Liste des Packagings</NavLink></li>
                        <li><NavLink to="/packagings/history">Historique</NavLink></li>
                    </ul>
                </nav>

                <Outlet />
            </main>
        </HelmetProvider>
    )
}
